
/**
 * 수강신청 유형
 */
export type EnrollCourseBodyEnrollmentType = typeof EnrollCourseBodyEnrollmentType[keyof typeof EnrollCourseBodyEnrollmentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnrollCourseBodyEnrollmentType = {
  REGULAR: 'REGULAR',
  AUDIT: 'AUDIT',
  PREMIUM: 'PREMIUM',
  TRIAL: 'TRIAL',
} as const;
